import type { OperationMode } from "../../../../../http/lock_calculator/types";

/** The elements "go to" can reach, by key: a form path for a field, `action:<mode>` for a calculation button. */
export type NoticeTargets = {
  register: (key: string, element: HTMLElement | null) => void;
  find: (key: string) => HTMLElement | null;
};

export const actionTargetKey = (action: OperationMode): string => `action:${action}`;

export const createNoticeTargets = (): NoticeTargets => {
  const elements = new Map<string, HTMLElement>();
  return {
    register: (key, element) => {
      if (element) elements.set(key, element);
      else elements.delete(key);
    },
    find: (key) => elements.get(key) ?? null,
  };
};
